export class FrontOfficeRequestFilter {
    startDate: string = "";
    endDate: string = "";
    defined: boolean = false;
    frontOffice: string = "";
    bank: string = "";
    neg: any[] = [];
    credit: any[] = [];
}
